import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { CaskType } from "@/app/services/generated/casktypeService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import { caskTypeService } from "@/app/services/generated/casktypeService";

// Singleton cache store
const caskTypesCacheStore = new EntityCacheStore<CaskType>(
  EnumCacheEntityType.caskType,
  async () => caskTypeService.getAllCaskTypes()
);

// Ephemeral reader
export default class CaskTypesCache extends EntityWithGuidKeyCache<CaskType> {
  constructor() {
    super(caskTypesCacheStore, (x) => x.id);
  }
}
